import type { FunctionComponent } from 'react';

import { useDarkMode } from '@shared/dark-mode';

import { DevToolsToggle } from '../DevToolsToggle';

export const DarkModeToggle: FunctionComponent = () => {
    const { isActive, toggleOverride } = useDarkMode();

    return <DevToolsToggle active={isActive} label="Dark mode" onToggle={toggleOverride} />;
};
